import every from 'lodash/every';
import some from 'lodash/some';
import values from 'lodash/values';
import entries from 'lodash/entries';
import orderBy from 'lodash/orderBy';
import unescape from 'lodash/unescape'
import isEqual from 'lodash/isEqual';
import moment from 'moment';
import { config } from '../../../config';
import { USER_STATUS_PENDING, TRIAL_PLANS, INTEGRATION_SIDEBAR_CONFIG, TAGS, CHECKLIST_UPDATE_CUSTOM_EVENT_KEY } from '../constants';
import { FREEMIUM_PLAN_ID } from '../../settings/constants';
import { getConfigKey } from '@hiver/hiver-config-library';
/**
 * Checks if given email is vaild type
 * @param {String} email
 */
function isValidEmail(email) {
    const emailRegex = /^[A-Z0-9'._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,25}$/i;
    if (emailRegex.test(email)) {
        return true;
    }
    return false;
}

/**
 * A valid domain must:
 * - Contain at least one dot (e.g., example.com)
 * - Have valid characters (letters, numbers, hyphens)
 * - End with a valid top-level domain (TLD) of at least 2 characters
 * - Not include protocols like http:// or https://
 * @param {string} domain - The domain name to validate
 * @returns {boolean} True if the domain is syntactically valid, false otherwise
 */
function isValidDomain(domain) {
    const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    return domainRegex.test(domain);
  }

/**
 * Checks if given domain is vaild
 * @param {String} email
 */
 function isValidDomainAddress(email) {
    const domainRegex = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/g;
    return domainRegex.test(email);
}


function isValidWebsiteUrl(url) {
    const websiteRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+)(\/[^\s]*)?$/;
    return websiteRegex.test(url);
}

/**
 * Checks if given number is valid number
 * @param {Number} number
 */
function isNumeric(number) {
    return !isNaN(parseFloat(number)) && isFinite(number);
}
/**
 * Checks if appview is gmail type
 */
function isGmailAppView() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function setSessionIdToUrl(url, sessionId) {
    if (!(typeof sessionId === 'number' || typeof sessionId === 'string')) return url;
    const regEx = /(\?|&)usersession=(\d)/;
    if (regEx.test(url)) return url;
    const parts = url.split('?');
    return parts[1] ? `${parts[0]}?${parts[1]}&usersession=${sessionId}` : `${parts[0]}?usersession=${sessionId}`;
}

/**
 * Checks if appview is gmail type
 */
function getUserSession() {
    const url = new URL(window.location.href);
    return parseInt(url.searchParams.get("usersession"));
}

function unescapeFields(list){
    return list.map((item) => typeof item === 'string' ? unescape(item): item);
}

/**
 * 
 * used to join an array values
 * 1. discard those values which are null or undefined
 * 2. join those filetred values with the operator passed
 * eg -  getJoinedString([abc, null, efg], '-') = abc-efg
 */
function getJoinedString(values, joinWith){
  if(!Array.isArray(values)){
      return ''
  }
  return values.filter(item => item).join(joinWith);
}

/**
 * Checks if onboarding mode
 */
function isOnboardingView() {
    const url = new URL(window.location.href);
    const onboarding = url.searchParams.get("onboarding");
    return (onboarding === 'true');
}

function buildIframeUrl(url, _usersession_id) {
    if (isGmailAppView()) {
        url = replaceUrlParam(url, 'appview', 'gmail');
    }
    url = replaceUrlParam(url, 'usersession', _usersession_id);
    return url;
}

function replaceUrlParam(url, paramName, paramValue) {
    if (url.indexOf('#') == 0 || url.indexOf("javascript") > -1)
        return url;
    var pattern = new RegExp('(' + paramName + '=).*?(&|$)');
    var newUrl = url;
    if (url.search(pattern) >= 0) {
        newUrl = url.replace(pattern, '$1' + paramValue + '$2');
    }
    else {
        newUrl = newUrl + (newUrl.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    return newUrl;
}
/**
 * Returns an object of type { label: 'labelname', value: 'value' } which is used by react-select
 * @param {Array} users
 * @param {Array} groups
 */
function getUsersAndGroups(users, groups, showEmailInLabel = false) {
    const options = [];
    users.forEach((user) => {
        const { firstname, lastname, email, name, avatar_url, avatarColor, id, status } = user;
        let fullName = `${firstname} ${lastname}`;
        let labelName = `${firstname} ${lastname}  ${showEmailInLabel ? (' (' + email + ')') : ''}`;
        let isInvited = status === 'pending' ? 1 : 0;
        if (showEmailInLabel) {
            labelName = `${user.first_name} ${user.last_name}  ${showEmailInLabel ? (' (' + email + ')') : ''}`;
        }
        if (!firstname && name && !showEmailInLabel) {
            labelName = `${name} ${lastname} (${email})`;
            fullName = `${name} ${lastname}`;
        }
        if (!firstname && !lastname && !showEmailInLabel) {
            labelName = `Invited (${email})`;
            fullName = labelName;
            isInvited = 1;
        }
        //okta use case
        if (isInvited && firstname && lastname) {
            labelName = `Invited (${email})`;
            fullName = labelName;
        }
        options.push({
            label: labelName, value: email, fullName,
            avatar_url, avatarColor, isInvited, type: 'user',
            id, email, firstname,lastname
        });
    });
    groups.forEach((group) => {
        const { email, avatar_url, avatarColor, id, name } = group;
        const fullName = name ? `${name} (${email})`: `Group (${email})`;
        options.push({
            label: fullName, value: email, fullName,
            avatar_url, avatarColor, type: 'group', id, email
        });
    });
    return options;
}
/**
 * Function responsible for capitalizingfirst letter of the string
 * @param {String} string The string for which capitalization needs to be done
 */
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
/**
 * Returns promise with setTimeout
 * @param {Number} time
 */
function delay(time) {
    return new Promise(function (resolve) {
        setTimeout(resolve.bind(null), time);
    });
}
/**
 * Decode special symbols like &amp; -> &
 * @param {String} content
 */
function decodeSpecialSymbols(content) {
    const elem = document.createElement('textarea');
    elem.innerHTML = content;
    return elem.value;
}

/**
 * Returns the text from a HTML string
 *
 * @param {html} String The html string
 */
function stripHtml(html) {
    // Create a new div element
    var temporalDivElement = document.createElement("div");
    // Set the HTML content with the providen
    temporalDivElement.innerHTML = html;
    // Retrieve the text property of the element (cross-browser support)
    return temporalDivElement.textContent || temporalDivElement.innerText || "";
}

function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

function removeElementFromArr(arr, element) {
    const index = arr.indexOf(element);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
}
/**
 * array of user objects
 * @param {Array} userArr
 */
function getSortedUsers(userArr) {
    const invitedUsers = orderBy(userArr.filter((user) => { return !user.name; }), ['email'], ['asc']);
    const inviteAccepted = orderBy(userArr.filter((user) => { return user.name; }), ['name'], ['asc']);
    const combinedUsers = invitedUsers.concat(inviteAccepted);
    return combinedUsers;
}
/**
 * Sorts user array, invited users are in the first part of array
 * and adds randomcolor field into the user object
 * @param {Array} userArr array containing invited and inviteaccepted users
 */
function getSortedUsersWithAvatarColors(userArr) {
    const combinedUsers = getSortedUsers(userArr);
    const newUserArray = combinedUsers.map((user) => {
        if (!user["avatarColor"]) {
            user["avatarColor"] = getRandomColor();
        }
        return user;
    });
    return newUserArray;
}
/**
 * [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
 * createGroupedArray(arr, 4);
 * result: "[[1,2,3,4],[5,6,7,8],[9,10,11,12],[13,14]]"
 * @param {Array} arr array to be chunked
 * @param {Integer} chunkSize chunk size of each array
 */
function createGroupedArray(arr, chunkSize) {
    var groups = [], i;
    for (i = 0; i < arr.length; i += chunkSize) {
        groups.push(arr.slice(i, i + chunkSize));
    }
    return groups;
}
/**
 * Calculates total cost based on number of users added
 * @param {Number} numberOfUsersAdded additional users added
 * @param {String} planType monthly/yearly
 * @param {Number} perUserCost in cents
 */
function getAdditionalCostForUser(numberOfUsersAdded, planType, perUserCost) {
    const userCost = (planType.toLowerCase() === "monthly") ? perUserCost / 100 : perUserCost / 1200;
    let finalCostInDollar = parseInt(numberOfUsersAdded) * userCost;

    // rounding it off upto 2 decimal places
    return parseFloat(finalCostInDollar.toFixed(2));
}
function isValidPhoneNumber(string) {
    const regex = /\+[1-9]{1}[0-9]{3,14}$/;
    return regex.test(string);
}

function toTitleCase(string) {
    return string[0].toLocaleUpperCase() + string.slice(1);
}

function handleInvitedUser(user) {
    user.avatarColor = "#efefef";
    user.avatar_url = null;
    if (user.firstname && !user.lastname)
        user.lastname = '';
    if (!user.firstname && user.lastname)
        user.firstname = '';
    if (user.status === USER_STATUS_PENDING) {
        user.firstname = 'Invited';
        user.lastname = `(${user.email})`;
    }
    user.disabled = true;
    return user;
}

function userListSort(a, b) {
    if (a.status === 'pending' && b.status !== 'pending')
        return -1;
    else if (a.status !== 'pending' && b.status === 'pending')
        return 1;
    else
        return a.email.localeCompare(b.email);
}

function isValidURL(url) {
    const regEx = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    return regEx.test(url);
}

function isExtensionInstalled() {
    return !!document.getElementById('hiverhq_extension_version');
}

function objectHasDataInEveryField(obj) {
    return every(values(obj), v => typeof v === 'object' ? objectHasDataInEveryField(v) : !!v);
}

function objectHasSomeData(obj, arrayLengthCheck) {
    return some(values(obj), v => {
        if (arrayLengthCheck && Array.isArray(v)) {
            return v.length > 0
        } else
            return typeof v === 'object' ? objectHasSomeData(v, arrayLengthCheck) :  !!v
    });
}
function areTwoObjectsSame(obj1, obj2){
    return isEqual(obj1, obj2);
}

function getIntegersParsedObject(obj) {
    entries(obj).forEach(([key, value]) => {
        if (typeof value === 'object')
            if (key !== TAGS)
                obj[key] = getIntegersParsedObject(value);
        else if (isNumeric(value))
            obj[key] = parseInt(value);
    });
    return obj;
}

function planChargeInDollars(cents, type,isAnnualPricingRequired=false)
{
    // validate input
    if (typeof cents !== 'number')
        return '';

    // to convert cents into dollar
    let result = cents / 100;

    // to obtain per month cost
    let isAnnual = typeof type === 'string' && type.toLowerCase() === 'annual';
    let finalCostInDollar = (isAnnual && !isAnnualPricingRequired) ? (result / 12) : result;

    // rounding it off upto 2 decimal places
    return parseFloat(finalCostInDollar.toFixed(2));
}

function getDaysLeftInTrial(validTo) {
    return moment(validTo).diff(moment(), 'days') + 1;
}

//talks to extension to update onboarding state
export function extensionSMOnboardingDone(smid, showOnboardingPlgGuiders) {
    sendMessageToParentWindow('SmCreate', {
        taskType: 'SmCreate',
        smid: smid,
        methodType: 'Create',
        showOnboardingPlgGuiders
    })
}
export function gtag_report_conversion(target, redirect = false) {
    if (config.API_ROOT_URL !== 'https://v2.hiverhq.com')
        return;
    var sendTo;
    switch(target) {
        case 'signup':
            sendTo = 'AW-1017039112/6_ClCNKoiHEQiJL75AM';
            break;
        case 'upgrade':
            sendTo = 'AW-1017039112/-ytYCNOhgnEQiJL75AM';
            break;
        default:
            return;
    }
    var callback = function (url) {
        if (typeof(url) != 'undefined') {
            if (redirect)
                window.location = url;
        }
    };
    if (window.gtag) {
        window.gtag('event', 'conversion', {
            'send_to': sendTo,
            'event_callback': callback
        });
    }
    return false;
}
export function groupBy(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

/**
 * Function to check whether the specified feature(featureName) is availabe or not.
 * @param {Array} availableFeatures 
 * @param {String} featureName 
 */
function isFeatureEnabled(availableFeatures, featureName) {
    return availableFeatures.some((feature) =>
      feature.key === featureName && feature['is_available']
    );
}

function isFeatureAvailableForProduct(availableFeatures, featureName, product) {
    return availableFeatures.some((feature) =>
      feature.key === featureName && feature['products'].includes(product)
    );
}

function isNewPlan21(planDetails = {}) {
    //Adding Freemium ID here because it was added in 2024 but plan ID was decided to be 31.
    return planDetails.planid === FREEMIUM_PLAN_ID || planDetails.planid >= 1400; 
}

/**
 * Find duplicate 
 * @param {Array} userList
 */
function findDupesInList(list) {
    var counts = {};
    list.forEach((item) => {
        if (counts.hasOwnProperty(item)) {
            counts[item]++
        } else {
            counts[item] = 1
        }
    })
    return Object.keys(counts).filter(item => counts[item] > 1)
            .reduce((agg, curr) => ({ 
                ...agg, [curr]: counts[curr]
            }),{})
}

function checkIsNewSmUi ({userDetails}){
    const { planDetails, availableFeatures, first_sm_created} = userDetails;
    const isInIframe = document.getElementsByClassName('h-topbar-container').length > 0;
    return (
        planDetails &&  
        TRIAL_PLANS.includes(planDetails.planid)  && 
        isFeatureEnabled(availableFeatures,"ftr-onboarding-experiment") && 
        !first_sm_created &&
        !isInIframe
    )
}

function sendMessageToParentWindow(key, extraParams = {}) {
    window.parent && window.parent.postMessage({ 'taskType': key, ...extraParams }, 'https://mail.google.com');
    window.parent.parent && window.parent.parent.postMessage({ 'taskType': key, ...extraParams }, 'https://mail.google.com');
}

export const copyToClipboard = (str) => {
  const el = document.createElement("textarea");
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

function downloadFileFromUrl(url, fileName){
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.click();
    link.remove();
 } 


function callAllFunction(...func) {
    return (...args) => {
        func.forEach((myFunc) => {
            typeof myFunc === 'function' && myFunc(...args);
        })
    }
}

// Order of Props matters, next parameter prop will override the first parameter prop
function combineProps(...listOfprops) {
    return Object.assign({}, ...listOfprops)
}

function deepClone(value) {
    return JSON.parse(JSON.stringify(value));
}

const dispatchApprovalEvent = (message, data) => {
    const event = new CustomEvent('APPROVALS_EVENT', {detail:{
        message,
        data
    }})
    window.dispatchEvent(event)
};

const hasUpgradeLeftbar = (routes, feature, availableFeatures) => {
    routes.forEach((routeItem) => {
        if (feature.includes(routeItem.label)) {
            routeItem.hasUpgrade = INTEGRATION_SIDEBAR_CONFIG.features.every(featKey => !isFeatureEnabled(availableFeatures, featKey));
        } 
    });
    return routes;
};

const goToGmail = () => {
    if (!isGmailAppView()) {
        window.location.replace("https://mail.google.com");
        return;
    }
    window.parent?.postMessage({ 'taskType': 'toGmail' }, 'https://mail.google.com');
    window.parent?.parent?.postMessage({ 'taskType': 'toGmail' }, 'https://mail.google.com');
}

//Returns the value of app_env and tier in different env (used to make Bifrost API call) 
const getEnv = () => {
    //Buddy QA Env
	let app_env = config.APP_ENV;
	let tier = 'sit';

    // Production Env
	if (process.env.NODE_ENV.toLowerCase() === 'production' && !config.CI_MODE) {
		app_env = 'v2master';
		tier = 'production';
	} else if (config.APP_ENV.toLowerCase() === 'dev') {
		// Buddy-CLI env
        app_env = 'dev';
		tier = 'dev';
	}
	return {app_env, tier};
}

// Remove query param from current window url without reloading
function removeQueryParam(paramToRemove) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    params.delete(paramToRemove);

    const currentState = history.state;
    const currentTitle = document.title;
    window.history.replaceState(currentState, currentTitle, url.toString());
}

// Check if is admin or mainbox admin 
const isAdminOrMailBoxAdmin = (userPermissions) => {
    const requiredPermissions = ['sm.full', 'sm.partial']
    return requiredPermissions.some(permission => userPermissions.includes(permission))
};

const handleChecklistStateUpdate = ({ isAvailable, usergroupProperties, setUsergroupProperty, property, value, panelStatus = true }) => {
    if (!isAvailable || (usergroupProperties[property] && JSON.parse(usergroupProperties[property])?.isCompleted)) {
        return;
    }

    const params = {
        panelStatus,
        ugProperty: {
            property,
            value,
        }
    }
    setUsergroupProperty(property, value);
    setTimeout(()=> sendMessageToParentWindow(CHECKLIST_UPDATE_CUSTOM_EVENT_KEY, { params }), 1000)
}

const handleSmStateUpdate = ({ isAvailable, setSmProperty, smId, property, value, }) => {
    if (!isAvailable) {
        return;
    }
    setSmProperty({ smId, property, value });
}

const getHiverChatSupportLink = (emailId, firstName) => `https://cdn.hiverhq.com/chat-support/hiver-chat.html?email=${emailId}&name=${firstName}`;

/**
 * Create and downloads a csv file in local
 * @param {String} csvString
 */
const triggerCSVdownload = (csvString, downloadFileName) => {
    // Convert string to Blob
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
 
    // Create a URL for the Blob
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${downloadFileName}.csv`;
    
    // Append link, trigger download, and remove link
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
 
const stripTrailingCommas = s => {
    if (typeof s !== 'string') {
      return s;
    }
    let end = s.length;
    while (end && s.charCodeAt(end - 1) === 44) { // 44 == ','
      end--;
    }
    return s.slice(0, end);
}

 const scrollToBottomOfContainer = ({ id = "", delay = 0 }) => {
    const scrollContainer = document.getElementById(id);
    if (scrollContainer) {
      setTimeout(() => {
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: "smooth",
        });
      }, delay);
    }
  };

  const openMailUsingThreadId = (threadId) => {
    if(!threadId) return;
    const gmailRootUrl = "https://mail.google.com/mail/";
    let gmailRootAccountNumber = getConfigKey('GMAIL_ROOT_ACCOUNT_NUMBER');
    // if GMAIL_ROOT_ACCOUNT_NUMBER is not set/invalid, default to 0. PS: this config key is set by extension
    if(isNaN(Number(gmailRootAccountNumber))) {
        gmailRootAccountNumber = 0;
    }
    const url = `${gmailRootUrl}u/${gmailRootAccountNumber}/#all/${threadId}`;
    window.open(url, '_blank');
  }

export {
    isValidURL,
    deepClone,
    getUserSession,
    userListSort,
    isValidEmail,
    isValidDomain,
    isValidDomainAddress,
    isValidPhoneNumber,
    handleInvitedUser,
    isNumeric,
    isGmailAppView,
    setSessionIdToUrl,
    isOnboardingView,
    buildIframeUrl,
    getUsersAndGroups,
    capitalizeFirstLetter,
    delay,
    decodeSpecialSymbols,
    stripHtml,
    getRandomColor,
    removeElementFromArr,
    getSortedUsersWithAvatarColors,
    getSortedUsers,
    createGroupedArray,
    getAdditionalCostForUser,
    isExtensionInstalled,
    toTitleCase,
    objectHasDataInEveryField,
    objectHasSomeData,
    planChargeInDollars,
    areTwoObjectsSame,
    getDaysLeftInTrial,
    getIntegersParsedObject,
    isFeatureEnabled,
    isFeatureAvailableForProduct,
    findDupesInList,
    checkIsNewSmUi,
    isNewPlan21,
    sendMessageToParentWindow,
    unescapeFields,
    downloadFileFromUrl,
    getJoinedString,
    callAllFunction,
    combineProps,
    dispatchApprovalEvent,
    goToGmail,
    hasUpgradeLeftbar,
    getEnv,
    removeQueryParam,
    isAdminOrMailBoxAdmin,
    handleChecklistStateUpdate,
    handleSmStateUpdate,
    getHiverChatSupportLink,
    isValidWebsiteUrl,
    triggerCSVdownload,
    stripTrailingCommas,
    scrollToBottomOfContainer,
    openMailUsingThreadId
};
